"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GLOBAL = {
    currentVisualizer: null,
};
exports.default = GLOBAL;
//# sourceMappingURL=global.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/global.js
// module id = 79
// module chunks = 0 1